import React from 'react';
import moment from 'moment';
import {
    FunctionField, Show,
    SimpleShowLayout,
    TextField
} from 'react-admin';

const VasShow = (props: any) => {
    return (
        <Show {...props} actions={false}>
            <SimpleShowLayout>
                <TextField source="id" sortable={false}/>
                <TextField source="name" sortable={false}/>
                <TextField source="description" sortable={false}/>
                <FunctionField label="Created At" sortable={false} render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY') : '-'} />
                <FunctionField label="Updated At" sortable={false} render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY') : '-'} />
            </SimpleShowLayout>
        </Show>
    );
};

export default VasShow;